export const FETCH_SOCIETIES = 'society/FETCH_SOCIETIES';
export const FETCH_SOCIETY = 'client/FETCH_SOCIETY';
export const PUSH_SOCIETY = 'client/PUSH_SOCIETY';
